module.exports = __webpack_public_path__ + "5ed4d6468a5a0f3cf9c82f854936feab.ttf";